<template>
  <div id="cash">
    <div
      v-if="have"
      v-waterfall-lower="loadMore"
      waterfall-disabled="disabled"
      waterfall-offset="300"
    >
      <div class="fixed">
        <div class="thead">
          <span>奖品</span>
          <span>中奖时间</span>
          <span>兑换</span>
        </div>
      </div>
      <div class="line"></div>
      <div class="list" v-for="(item,index) in prizeList" :key="index">
        <span v-if="item.name.length > 7" class="min">{{item.name}}</span>
        <span v-else>{{item.name}}</span>
        <span>{{item.create_time}}</span>
        <span>
          <a v-if="item.exchange_status == 'no'" class="btn" @click="getCode(item)">立即兑换</a>
          <a v-else class="btn disabled">已兑换</a>
        </span>
      </div>
      <p v-show="noMore" class="nomore">数据加载完成</p>
    </div>
    <div v-else class="nothing">
      <img :src="imgPath+'nothing.png'" alt="暂无数据" />
    </div>

    <van-popup v-model="isShowQRimg">
      <div class="codebox">
        <p>兑奖二维码</p>
        <img :src="codeImg" />
        <p>兑奖码：{{qrCode}}</p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import tool, { app_Id } from "../../kits/Tools.js";
import vxxData from "../../kits/data.js";
import { Waterfall } from "vant";
import { Toast } from "vant";
import QRCoder from "qrcoder";
//保存数据

export default {
  directives: {
    WaterfallLower: Waterfall("lower")
  },
  data() {
    return {
      fansId: "",
      prizeList: [],
      have: true,
      page: 1,
      page_nums: 20,
      prizeType: 0,
      isShowQRimg: false,
      qrCode: "",
      disabled: false,
      noMore: false,
      timer: "",
      item: "",
      imgPath: "",
      codeImg: ""
    };
  },
  mounted() {
    var that = this;
    this.prizeType = this.$route.params.type;
    tool.login(app_Id, function(user) {
      that.fansId = user.fans_id;
      that.loadMore();
    });
    //     var current_app_Id = window.localStorage.getItem("current_app_Id");
    //     var fans = JSON.parse(window.localStorage.getItem(current_app_Id));
    this.imgPath = tool.imgPath();
    console.log(this.$route);
  },
  methods: {
    loadMore() {
      if (!this.fansId) {
        return;
      }
      var that = this;
      var option, url;
      if (this.prizeType == "0") {
        url = tool.baseUrl() + "/redRain/index/lists";
      } else {
        url = tool.baseUrl() + "/activity/shake/lists";
      }

      option =
        "fans_id=" +
        this.fansId +
        "&page=" +
        this.page +
        "&page_nums=" +
        this.page_nums;
      Toast.loading({ duration: 0 });
      this.disabled = true;
      this.axios
        .post(url, option)
        .then(function(res) {
          var data = res.data;
          Toast.clear();
          if (data.code == "200") {
            if (data.data.list) {
              that.prizeList = that.prizeList.concat(data.data.list);
            }
            that.page++;
            if (that.prizeList.length == 0) {
              that.have = false;
            }
            if (data.data.list.length < that.page_nums) {
              that.disabled = true;
              that.noMore = true;
            } else {
              that.disabled = false;
            }
          } else {
            Toast(data.message);
          }
        })
        .catch(function(res) {
          console.log("错误" + res);
        });
    },
    getCode(item) {
      var that = this;
      var url = tool.baseUrl() + "/fans/index/createLink";
      var option =
        "fans_id=" + this.fansId + "&type=2&code=" + item.exchange_code;
      //var option = 'fans_id='+this.fansId+'&type=2&code=20507283';
      this.item = item;
      this.axios
        .post(url, option)
        .then(function(res) {
          var data = res.data;
          if (data.code == "200") {
            var link;
            if (location.href.indexOf("?") != -1) {
              link = location.href.split("?")[0];
            } else {
              link = location.href.split("#")[0];
            }
            link +=
              "?type=" +
              data.data.type +
              "&data0=" +
              data.data.data0 +
              "&data1=" +
              data.data.data1 +
              "&data2=" +
              data.data.data2;
            link += "#/check";
            var qrcoder = new QRCoder({
              data: link,
              size: 225
            });
            that.codeImg = qrcoder.getDataURL();
            that.qrCode = item.exchange_code;
            that.isShowQRimg = true;
            console.log(link);
          } else {
            Toast(data.message);
          }
        })
        .catch(function(data) {
          Toast(data.message);
        });
    },
    cance(item) {
      var that = this;
      var url = tool.baseUrl() + "/fans/index/createLink";
      var option =
        "fans_id=" + this.fansId + "&type=2&code=" + item.exchange_code;
      this.axios
        .post(url, option)
        .then(function(res) {
          var data = res.data;
          if (data.code == "202") {
            that.isShowQRimg = false;
            Toast("核销成功");
            clearInterval(that.timer);
            setTimeout(function() {
              location.reload();
            }, 2000);
          }
        })
        .catch(function(data) {
          Toast(data.message);
        });
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    isShowQRimg() {
      var that = this;
      if (this.isShowQRimg) {
        this.timer = setInterval(function() {
          that.cance(that.item);
        }, 1000);
      } else {
        clearInterval(this.timer);
      }
    }
  }
};
</script>

<style scoped>
.fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #f94040;
  color: #fff;
  z-index: 1000;
}
.codebox {
  text-align: center;
}
.thead,
.list {
  display: flex;
  height: 50px;
}

.thead span,
.list span {
  flex: 2;
  text-align: center;
  height: 40px;
  line-height: 40px;
  position: relative;
  padding: 5px 0;
}

.thead span:nth-child(2),
.list span:nth-child(2) {
  flex: 3;
}

.thead span:nth-child(1):after,
.thead span:nth-child(2):after {
  content: "";
  height: 38px;
  width: 1px;
  background: #fff;
  top: 6px;
  right: 0;
  position: absolute;
}

.list span {
  color: #3f3f3f;
  font-size: 13px;
}

.list .min {
  line-height: 20px;
}

.list:nth-child(2n + 1) {
  background: #ffdfdf;
}

.list:nth-child(2n) {
  background: #ffeaea;
}

.list span:nth-child(1),
.list span:nth-child(2) {
  border-right: 1px solid #fff;
}

.list img {
  max-width: 40px;
  margin: 0 auto;
  max-height: 40px;
  vertical-align: middle;
}

.list .btn {
  margin: 5px auto;
  border-radius: 3px;
  background: #f94040;
  color: #fff;
  display: block;
  width: 70px;
  line-height: 30px;
}

.list .disabled {
  background: #999;
}

.line {
  height: 50px;
}
</style>